import Tray from './index'
import { assign, get } from 'lodash'
import React from 'react'

class SportsTray extends React.Component {
	constructor(props){
		super(props)
		this.options = {
			sharing: true,
			noBlockTitle: true,
			noPlayIcon: true,
			noBoxshadow: true
		}
		assign(props.data, this.options)
	}
	render(){
		return (
			<div className={`sports-tray ` + (get(this.props,'layout.settings.isHidden') ? 'hide': '') }>
				<Tray {...this.props}/>
			</div>
		)
	}
}

export default SportsTray
